// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ChevronRight = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ChevronRight = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ChevronRight = _exports.ChevronRight = function ChevronRight(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.70735 16.0029C7.55873 16.0029 7.41008 15.9464 7.29706 15.8326C7.07025 15.6058 7.07025 15.2381 7.29706 15.0113L12.3054 10.0028L7.29706 4.99439C7.07025 4.76758 7.07025 4.39985 7.29706 4.17304C7.52387 3.94623 7.89159 3.94623 8.1184 4.17304L13.537 9.59179C13.7638 9.8186 13.7638 10.1863 13.537 10.4131L8.1184 15.8319C8.00461 15.9465 7.85598 16.0029 7.70735 16.0029Z",
      fill: "#212B36"
    }));
  };
});
